import {
  cloneElement,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import InfoButton from '@/atoms/buttons/InfoButton';
import MuiPopover from '@mui/material/Popover';
import { Position } from '@/lib/enums';
import ModalColors from '../utils/ModalColors';
import originPosition from './utils/originPosition';

const Popover = forwardRef(function Popover(
  {
    Component = <InfoButton />,
    children,
    color = 'primary',
    disabled,
    onClose,
    onOpen,
    position = Position.BOTTOM,
    maxHeight,
  },
  ref
) {
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = useRef(null);
  const [origin, setOrigin] = useState();
  const colors = ModalColors[color];

  const handleClick = () => {
    if (disabled) {
      setAnchorEl(null);
      return;
    }
    setAnchorEl(anchorEl ? null : anchorRef.current);
    if (!anchorEl) {
      onOpen?.();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose?.();
  };

  useEffect(() => {
    setOrigin(originPosition(position));
  }, [position]);

  // Make the open event available to parent components.
  useImperativeHandle(ref, () => ({
    open(anchor) {
      setAnchorEl(anchor ?? anchorRef.current);
    },
    close() {
      handleClose();
    },
  }));

  return (
    <>
      {Boolean(Component) &&
        cloneElement(Component, { ref: anchorRef, onClick: handleClick })}
      {anchorEl && (
        <MuiPopover
          anchorOrigin={origin?.anchor}
          transformOrigin={origin?.transform}
          PaperProps={{
            elevation: 1,
            sx: {
              ...colors,
              borderRadius: '4px',
              mt: position === Position.TOP ? 1 : 0.5,
              maxHeight,
            },
          }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
        >
          {cloneElement(children, { onClose: handleClose })}
        </MuiPopover>
      )}
    </>
  );
});

export default Popover;
